import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router";
import ProductImageContainer from "~/containers/ProductImageContainer";
import { getUserSlug } from "~/util/getUserSlug";

export default class ProductImageModeration extends React.Component<
  RouteComponentProps<{}>
> {
  public render() {
    if (!getUserSlug()) {
      return (
        <Redirect
          to={{
            pathname: "/auth",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return <ProductImageContainer />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProductImageModeration.tsx